// Small view state that rides in the hash after the route, e.g.
// #organization/visibility/portfolio?r=7&f=team:t1&open=user:u0, so a reload
// or a shared link reopens the same view. Writes replace the history entry.

function split(hash = window.location.hash): [string, URLSearchParams] {
  const [route, q] = hash.split("?");
  return [route || "#", new URLSearchParams(q ?? "")];
}

export function getHashParam(key: string, hash?: string): string | null {
  return split(hash)[1].get(key);
}

export function setHashParam(key: string, value: string | null): void {
  const [route, q] = split();
  if (value) q.set(key, value);
  else q.delete(key);
  const rest = q.toString();
  const { pathname, search } = window.location;
  window.history.replaceState(
    null,
    "",
    pathname + search + route + (rest ? `?${rest}` : ""),
  );
}
